import { useEffect, useMemo, useState } from 'react';
import { FormasiBan } from './FormasiBan';
import { backendPort } from '../components/Fungsiku';
import api from "../services/axiosInstance";
import { ModalBanShow } from './Page28_BanShow';
import { ShowPic } from '../components/ShowPic';

function Page9ShowFormasiBanMaximized({
  formasi,
  cadangan,
  onClick,
  daftarKodeBan,
  unevenWearPosisi = [],
  buildBanTooltipData,
  buildBanIndikasiText,
}) {
  const unevenWearSet = new Set((Array.isArray(unevenWearPosisi) ? unevenWearPosisi : [unevenWearPosisi]).filter(Boolean));
  const getBanPalette = (id, isMapped, isWarning) => {
    const isCadangan = String(id || "").startsWith("S-");
    const base = isCadangan
      ? (isMapped
        ? { fill: "#c17f28", stroke: "#7c4a05", text: "#fff7ed" }
        : { fill: "#f0e2c6", stroke: "#b0894f", text: "#6b4f1d" })
      : (isMapped
        ? { fill: "#2f6ea3", stroke: "#133f66", text: "#f8fafc" }
        : { fill: "#d7e3f1", stroke: "#8aa0b8", text: "#334155" });
    if (!isWarning) return base;
    return {
      ...base,
      stroke: "#dc2626",
      strokeWidth: 4,
      shadow: "drop-shadow(0 0 6px rgba(244, 114, 182, 0.95))",
    };
  };
  const buildGridRows = () => {
    const total = Number(formasi || 0);
    const mk = (n) => `P-${String(n).padStart(2, '0')}`;
    const rows = [];
    const addEdgeRow = (left, right) => {
      rows.push([left || null, null, null, null, right || null]);
    };
    const addFourRow = (start) => {
      const four = [mk(start), mk(start + 1), mk(start + 2), mk(start + 3)].map((pos) => {
        const idx = Number(String(pos).slice(2));
        return idx <= total ? pos : null;
      });
      rows.push([four[0], four[1], null, four[2], four[3]]);
    };

    if (total >= 1) addEdgeRow(mk(1), total >= 2 ? mk(2) : null);
    if (total === 8) {
      addEdgeRow(total >= 3 ? mk(3) : null, total >= 4 ? mk(4) : null);
      addFourRow(5);
    } else {
      if (total >= 3) addFourRow(3);
      if (total >= 7) addFourRow(7);
      if (total === 16) {
        addEdgeRow(mk(11), mk(12));
        addEdgeRow(mk(13), mk(14));
        addEdgeRow(mk(15), mk(16));
      } else {
        if (total >= 11) addFourRow(11);
        if (total >= 15) addFourRow(15);
        if (total >= 19) addFourRow(19);
      }
    }

    const spareTotal = Number(cadangan || 0);
    if (spareTotal > 0) {
      for (let i = 1; i <= spareTotal; i += 1) {
        const rowIdx = i;
        while (rows.length <= rowIdx) rows.push([null, null, null, null, null]);
        rows[rowIdx][2] = `S-${i}`;
      }
    }
    return rows.filter((row) => row.some(Boolean));
  };
  const gridRows = buildGridRows();
  const renderIndikasiValue = (rawValue) => {
    const text = String(rawValue || "-").trim() || "-";
    if (text === "-") return text;
    const parts = text.split(",").map((part) => String(part || "").trim()).filter(Boolean);
    return parts.map((part, idx) => {
      const normalized = part.toLowerCase();
      const isHighlight = normalized === "aus tidak merata" || normalized === "td tidak seimbang";
      const display = normalized === "td tidak seimbang" ? "TD tidak seimbang" : part;
      return (
        <span key={`${normalized}-${idx}`} className={isHighlight ? "page9show-indikasi-alert" : undefined}>
          {idx > 0 ? ", " : ""}{display}
        </span>
      );
    });
  };
  const BanInfo = ({ id }) => {
    const idBan = Number(daftarKodeBan?.[id] || 0);
    const isMapped = Boolean(idBan);
    const isUnevenWear = unevenWearSet.has(id);
    const palette = getBanPalette(id, isMapped, false);
    const info = typeof buildBanTooltipData === "function" ? buildBanTooltipData(idBan) : null;
    const indikasi = typeof buildBanIndikasiText === "function" ? buildBanIndikasiText(id, idBan) : "-";
    const rows = [
      ["Seri", String(info?.seri || "-").trim() || "-"],
      ["Status", String(info?.status || "-").trim() || "-"],
      ["KM Tempuh", String(info?.km || "-").trim() || "-"],
      ["TD", String(info?.td || "-").trim() || "-"],
      ["Indikasi", String(indikasi || "-").trim() || "-"],
    ];

    return (
      <button
        type="button"
        onClick={() => (typeof onClick === "function" ? onClick(id) : null)}
        className={`page9show-ban-info-card${isUnevenWear ? ' is-uneven' : ''}${id === 'P-01' ? ' is-p01' : ''}${id === 'P-02' ? ' is-p02' : ''}`}
        data-ban-hover="1"
        style={{
          '--page9-ban-fill': palette.fill,
          '--page9-ban-stroke': palette.stroke,
          '--page9-ban-stroke-width': `${Number(palette?.strokeWidth || 2)}px`,
          '--page9-ban-shadow': palette?.shadow || 'none',
        }}
      >
        <div className="page9show-ban-info">
          <div className="page9show-ban-info-pos">{id}</div>
          {rows.map(([label, value]) => (
            <div className="page9show-ban-info-row" key={`${id}-${label}`}>
              <span>{label}</span>
              <strong>{label === "Indikasi" ? renderIndikasiValue(value) : value}</strong>
            </div>
          ))}
        </div>
      </button>
    );
  };
  const BlankCell = () => <div className="page9show-ban-info-spacer" aria-hidden="true" />;

  return (
    <div className="formasi-ban-surface page9show-formasi-maximized rounded-4">
      <div className="page9show-ban-info-grid">
        {gridRows.map((row, rowIdx) => (
          <div className="page9show-ban-info-grid-row" key={`row-${rowIdx}`}>
            {row.map((pos, colIdx) => (
              pos ? <BanInfo key={pos} id={pos} /> : <BlankCell key={`blank-${rowIdx}-${colIdx}`} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function PageKonten9_Show({globalOpsi, editData, setShowDetail, setShowMaster, reloadToken = 0}) {
  const opsiCabang = globalOpsi?.opsiCabang || [];
  const opsiMT = globalOpsi?.opsiMT || [];
  const formatTglUntukUI = (value) => {
      if (!value) return "-";
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return "-";
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${day}/${month}/${year}`;
  };
  
  const cadangan = Number(editData?.cadangan || 0);
  const formasi = Number(editData?.roda || 0);
  const daftarLampiran = Array.isArray(editData?.lampiran) ? editData.lampiran : [];
  const namaCabang = opsiCabang.find((x) => x.kode_cabang === editData?.kode_cabang)?.nama_cabang || '-';
  const [historyMtRows, setHistoryMtRows] = useState([]);
  const [loadingHistoryMt, setLoadingHistoryMt] = useState(false);
  const [showPosisiHistoryModal, setShowPosisiHistoryModal] = useState(false);
  const [loadingPosisiHistory, setLoadingPosisiHistory] = useState(false);
  const [posisiHistoryRows, setPosisiHistoryRows] = useState([]);
  const [selectedHistoryPosisi, setSelectedHistoryPosisi] = useState('');
  const [odoAkhir, setOdoAkhir] = useState(0);
  const [kmtAkhir, setKmtAkhir] = useState(0);
  const [showBanDetailModal, setShowBanDetailModal] = useState(false);
  const [selectedBanPosisi, setSelectedBanPosisi] = useState('');
  const [daftarBanMap, setDaftarBanMap] = useState({});
  const [openLampiranModal, setOpenLampiranModal] = useState(false);
  const [selectedLampiranFiles, setSelectedLampiranFiles] = useState([]);
  const [isBanTerpasangMaximized, setIsBanTerpasangMaximized] = useState(false);
  const [hoverBanTooltip, setHoverBanTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    owner: '',
    pos: '',
    id_ban: 0,
  });
  const [banMetaById, setBanMetaById] = useState({});

  useEffect(() => {
    let ignore = false;
    const loadDaftarBan = async () => {
      const idMt = String(editData?.id_mt || '').trim();
      if (!idMt) {
        setDaftarBanMap({});
        return;
      }
      try {
        const { data } = await api.get(`${backendPort}/api/main/load_daftarkodeban/${idMt}`);
        if (ignore) return;
        let parsed = {};
        if (typeof data === 'string') {
          try {
            parsed = JSON.parse(data || '{}') || {};
          } catch {
            parsed = {};
          }
        } else if (data && typeof data === 'object') {
          parsed = data;
        }
        setDaftarBanMap(parsed);
      } catch {
        if (!ignore) setDaftarBanMap({});
      }
    };
    loadDaftarBan();
    return () => {
      ignore = true;
    };
  }, [editData?.id_mt, reloadToken]);

  useEffect(() => {
    let ignore = false;
    const loadLastOdo = async () => {
      const idMt = String(editData?.id_mt || '').trim();
      if (!idMt) {
        setOdoAkhir(0);
        setKmtAkhir(0);
        return;
      }
      try {
        const { data } = await api.get(`${backendPort}/api/main/load_last_odo_mt/${idMt}`);
        if (ignore) return;
        setOdoAkhir(Number(data?.odo || 0));
        setKmtAkhir(Number(data?.kmt_mt || 0));
      } catch {
        if (!ignore) {
          setOdoAkhir(0);
          setKmtAkhir(0);
        }
      }
    };
    loadLastOdo();
    return () => {
      ignore = true;
    };
  }, [editData?.id_mt, reloadToken]);

  useEffect(() => {
    let ignore = false;
    const ids = Array.from(new Set(
      Object.values(daftarBanMap || {})
        .map((x) => Number(x || 0))
        .filter((x) => Number.isFinite(x) && x > 0)
    ));
    if (!ids.length) {
      setBanMetaById({});
      return undefined;
    }
    (async () => {
      try {
        const [metaRes, eventRes] = await Promise.all([
          api.post(`${backendPort}/api/main/load_daftarBanThisMT_initial`, { kodeBan: ids }),
          api.post(`${backendPort}/api/main/load_ban_event_history_by_ban`, {
            kodeBan: ids,
            latestOnly: true,
          }),
        ]);
        if (ignore) return;
        const next = {};
        const rowsMeta = Array.isArray(metaRes?.data) ? metaRes.data : [];
        rowsMeta.forEach((row) => {
          const idBan = Number(row?.id_ban || row?.id || 0);
          if (!idBan) return;
          next[idBan] = {
            ...(next[idBan] || {}),
            id_ban: idBan,
            seri_ban: String(row?.seri_ban || row?.seri || '').trim(),
            status: String(row?.status || row?.status_terakhir || '').trim(),
            km_tempuh: Number(row?.kmt_profil || next?.[idBan]?.km_tempuh || 0) || 0,
            td: String(row?.td_profil || next?.[idBan]?.td || '').trim(),
          };
        });
        const rowsEvent = Array.isArray(eventRes?.data) ? eventRes.data : [];
        rowsEvent.forEach((row) => {
          const idBan = Number(row?.id_ban || 0);
          if (!idBan) return;
          next[idBan] = {
            ...(next[idBan] || {}),
            id_ban: idBan,
            status: String(row?.status || next?.[idBan]?.status || '').trim(),
            km_tempuh: Number(next?.[idBan]?.km_tempuh || row?.kmt || 0) || 0,
            td: String(next?.[idBan]?.td || row?.td || '').trim(),
          };
        });
        setBanMetaById(next);
      } catch (err) {
        if (!api.isCanceledError?.(err) && !ignore) {
          setBanMetaById({});
        }
      }
    })();
    return () => {
      ignore = true;
    };
  }, [daftarBanMap]);

  const formatKmForUi = (value) => {
    const num = Number(value);
    if (!Number.isFinite(num) || num <= 0) return '-';
    return num.toLocaleString('id-ID');
  };
  const buildBanTooltipData = (idBan) => {
    const id = Number(idBan || 0);
    if (!id) return null;
    const meta = banMetaById?.[id] || {};
    const seri = String(meta?.seri_ban || `ID ${id}`).trim() || `ID ${id}`;
    const status = String(meta?.status || '-').trim() || '-';
    const km = formatKmForUi(
      meta?.km_tempuh
      ?? meta?.kmtotal
      ?? meta?.odo
      ?? meta?.km
      ?? 0
    );
    const td = String(meta?.td || meta?.td_terakhir || '-').trim() || '-';
    return { id_ban: id, seri, status, km, td };
  };
  const hideBanTooltip = () => {
    setHoverBanTooltip((prev) => ({ ...prev, visible: false }));
  };
  const showBanTooltip = ({ owner = '', pos = '', id_ban = 0, x = 0, y = 0 } = {}) => {
    const id = Number(id_ban || 0);
    if (!id) return;
    setHoverBanTooltip({
      visible: true,
      x: Number(x || 0),
      y: Number(y || 0),
      owner: String(owner || '').trim(),
      pos: String(pos || '').trim(),
      id_ban: id,
    });
  };
  const hoverBanData = buildBanTooltipData(hoverBanTooltip?.id_ban);
  const parseTdMinValue = (tdRaw) => {
    const text = String(tdRaw || '').trim();
    if (!text) return null;
    const parts = text.match(/\d+/g) || [];
    const nums = parts.map((x) => Number(x)).filter((x) => Number.isFinite(x));
    if (!nums.length) return null;
    return Math.min(...nums);
  };
  const parseTdSpreadValue = (tdRaw) => {
    const text = String(tdRaw || '').trim();
    if (!text) return null;
    const parts = text.match(/\d+/g) || [];
    const nums = parts.map((x) => Number(x)).filter((x) => Number.isFinite(x));
    if (!nums.length) return null;
    return Math.max(...nums) - Math.min(...nums);
  };
  const buildTdPairList = (formasiValue) => {
    const pairs = [];
    const formasiNum = Number(formasiValue || 0);
    if (!Number.isFinite(formasiNum) || formasiNum <= 0) return pairs;
    const mk = (n) => `P-${String(n).padStart(2, '0')}`;
    const add = (a, b) => {
      if (a > formasiNum || b > formasiNum) return;
      pairs.push([mk(a), mk(b)]);
    };
    if (formasiNum === 8) {
      add(5, 6);
      add(7, 8);
      return pairs;
    }
    [3, 7, 11, 15, 19].forEach((base) => {
      if (formasiNum === 16 && base >= 11) return;
      add(base, base + 1);
      add(base + 2, base + 3);
    });
    return pairs;
  };
  const calcTdWarningPosisi = (banMap = {}, formasiValue = 0) => {
    const warn = new Set();
    const pairs = buildTdPairList(formasiValue);
    pairs.forEach(([p1, p2]) => {
      const id1 = Number(banMap?.[p1] || 0);
      const id2 = Number(banMap?.[p2] || 0);
      if (!id1 || !id2) return;
      const td1 = parseTdMinValue(banMetaById?.[id1]?.td);
      const td2 = parseTdMinValue(banMetaById?.[id2]?.td);
      if (td1 == null || td2 == null) return;
      if (Math.abs(td1 - td2) >= 3) {
        warn.add(p1);
        warn.add(p2);
      }
    });
    return Array.from(warn);
  };
  const calcUnevenWearPosisi = (banMap = {}) => {
    const warn = new Set();
    Object.entries(banMap || {}).forEach(([pos, idBan]) => {
      const id = Number(idBan || 0);
      if (!id) return;
      const spread = parseTdSpreadValue(banMetaById?.[id]?.td);
      if (spread == null) return;
      if (spread >= 3) warn.add(String(pos || '').trim());
    });
    return Array.from(warn);
  };
  const tdWarningPosisi = useMemo(
    () => calcTdWarningPosisi(daftarBanMap, formasi),
    [daftarBanMap, formasi, banMetaById]
  );
  const unevenWearPosisi = useMemo(
    () => calcUnevenWearPosisi(daftarBanMap),
    [daftarBanMap, banMetaById]
  );
  const hoverIndikasiText = useMemo(() => {
    const idBan = Number(hoverBanTooltip?.id_ban || 0);
    if (!idBan) return '-';
    const pos = String(hoverBanTooltip?.pos || '').trim();
    const indications = [];
    const spread = parseTdSpreadValue(banMetaById?.[idBan]?.td);
    if (spread != null && spread >= 3) indications.push('aus tidak merata');
    if (pos && tdWarningPosisi.includes(pos)) indications.push('td tidak seimbang');
    if (!indications.length) return '-';
    return Array.from(new Set(indications)).join(', ');
  }, [hoverBanTooltip?.id_ban, hoverBanTooltip?.pos, banMetaById, tdWarningPosisi]);
  const buildBanIndikasiText = (posRaw, idBanRaw) => {
    const idBan = Number(idBanRaw || 0);
    if (!idBan) return '-';
    const pos = String(posRaw || '').trim();
    const indications = [];
    const spread = parseTdSpreadValue(banMetaById?.[idBan]?.td);
    if (spread != null && spread >= 3) indications.push('aus tidak merata');
    if (pos && tdWarningPosisi.includes(pos)) indications.push('td tidak seimbang');
    if (!indications.length) return '-';
    return Array.from(new Set(indications)).join(', ');
  };

  useEffect(() => {
    const onMouseMove = (event) => {
      if (!hoverBanTooltip?.visible) return;
      const hit = event?.target;
      const inBanHover = Boolean(hit?.closest?.('[data-ban-hover="1"]'));
      if (!inBanHover) hideBanTooltip();
    };
    window.addEventListener('mousemove', onMouseMove);
    return () => {
      window.removeEventListener('mousemove', onMouseMove);
    };
  }, [hoverBanTooltip?.visible]);

  useEffect(() => {
    let ignore = false;
    const loadHistoryMt = async () => {
      const idMt = String(editData?.id_mt || '').trim();
      if (!idMt) {
        setHistoryMtRows([]);
        return;
      }
      setLoadingHistoryMt(true);
      try {
        const { data } = await api.get(`${backendPort}/api/main/load_mt_event_history/${idMt}`);
        if (ignore) return;
        const rows = Array.isArray(data) ? data : [];
        setHistoryMtRows(rows);
      } catch {
        if (!ignore) setHistoryMtRows([]);
      } finally {
        if (!ignore) setLoadingHistoryMt(false);
      }
    };
    loadHistoryMt();
    return () => {
      ignore = true;
    };
  }, [editData?.id_mt, reloadToken]);

  const historyRows = useMemo(() => {
    const parseReff = (raw) => {
      if (!raw) return {};
      if (typeof raw === 'string') {
        try { return JSON.parse(raw || '{}') || {}; } catch { return {}; }
      }
      if (typeof raw === 'object') return raw;
      return {};
    };
    const normalizeReffValue = (value) => {
      if (value == null) return '';
      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        return String(value).trim();
      }
      if (Array.isArray(value)) {
        return value.map((x) => normalizeReffValue(x)).filter(Boolean).join(', ');
      }
      if (typeof value === 'object') {
        const entries = Object.entries(value)
          .map(([k, v]) => {
            const val = normalizeReffValue(v);
            return val ? `${k}:${val}` : '';
          })
          .filter(Boolean);
        return entries.join(', ');
      }
      return '';
    };
    const toTitleKey = (rawKey) => {
      const key = String(rawKey || "").trim().replace(/_/g, " ");
      if (!key) return "";
      return key
        .split(/\s+/)
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(" ");
    };
    const buildInfo = (_row, reff) => {
      const posisiList = (Array.isArray(reff?.ban) ? reff.ban : [])
        .map((item) => String(item?.posisi || "").trim())
        .filter(Boolean);
      const entries = Object.entries(reff || {})
        .filter(([k]) => {
          const key = String(k || '').trim().toLowerCase();
          return key !== 'nomor' && key !== 'ban';
        })
        .map(([k, v]) => {
          const key = toTitleKey(k);
          const val = normalizeReffValue(v);
          if (!key && !val) return '';
          if (!key) return val;
          if (!val) return key;
          return `${key}: ${val}`;
        })
        .filter(Boolean);
      if (posisiList.length) {
        entries.unshift(`Posisi: ${posisiList.join(", ")}`);
      }
      return entries.length ? entries.join(' | ') : '-';
    };

    return historyMtRows.map((row) => {
      const eventName = String(row?.event_mt || '-').toLowerCase();
      const reffObj = parseReff(row?.reff);
      let variant = 'neutral';
      if (eventName.includes('initial') || eventName.includes('migrasi')) variant = 'ok';
      else if (eventName.includes('mutasi') || eventName.includes('rotasi')) variant = 'alert';
      else if (eventName.includes('tambal') || eventName.includes('storing')) variant = 'link';

      return {
        label: String(row?.event_mt || '-').toUpperCase(),
        value: formatTglUntukUI(row?.tanggal),
        odo: Number(row?.odo || 0),
        kmtotal: Number(row?.kmtotal || 0),
        info: buildInfo(row, reffObj),
        variant
      };
    });
  }, [historyMtRows]);

  const normalizePlaceLabel = (rawPlace) => {
    const raw = String(rawPlace || '').trim();
    if (!raw) return '-';

    const gudangMatch = raw.match(/^gudang#([a-z0-9-]+)$/i);
    if (gudangMatch) {
      const kodeCabang = String(gudangMatch[1] || '').trim();
      const namaCabangMatch = (Array.isArray(opsiCabang) ? opsiCabang : [])
        .find((x) => String(x?.kode_cabang || '').trim().toLowerCase() === kodeCabang.toLowerCase());
      return `Gudang ${String(namaCabangMatch?.nama_cabang || kodeCabang).trim()}`;
    }

    const mtPlaceMatch = raw.match(/^([k]-[a-z0-9-]+)#([a-z0-9-]+)$/i);
    if (mtPlaceMatch) {
      const idMt = String(mtPlaceMatch[1] || '').trim();
      const posisi = String(mtPlaceMatch[2] || '').trim().toUpperCase();
      const mtRow = (Array.isArray(opsiMT) ? opsiMT : [])
        .find((x) => String(x?.id_mt || '').trim().toLowerCase() === idMt.toLowerCase());
      const nopol = String(mtRow?.nopol || idMt).trim();
      return `${nopol}-${posisi}`;
    }

    const pabrikMatch = raw.match(/^pabrik#(.+)$/i);
    if (pabrikMatch) {
      const namaSuplier = String(pabrikMatch[1] || '').trim();
      return `Pabrik ${namaSuplier}`;
    }

    return raw;
  };

  const normalizePlaceInText = (text) => {
    const raw = String(text || '').trim();
    if (!raw || raw === '-') return '-';
    return raw
      .replace(/\bgudang#([a-z0-9-]+)\b/gi, (m) => normalizePlaceLabel(m))
      .replace(/\b[k]-[a-z0-9-]+#[a-z0-9-]+\b/gi, (m) => normalizePlaceLabel(m))
      .replace(/\bpabrik#([^|,\n\r]+)/gi, (m) => normalizePlaceLabel(m));
  };
  const getEventVariant = (eventRaw) => {
    const eventName = String(eventRaw || '-').toLowerCase();
    if (eventName.includes('initial') || eventName.includes('migrasi')) return 'ok';
    if (eventName.includes('mutasi') || eventName.includes('rotasi')) return 'alert';
    if (eventName.includes('tambal') || eventName.includes('storing')) return 'link';
    return 'neutral';
  };

  const posisiList = useMemo(() => {
    const p = [];
    const maxP = Number.isFinite(formasi) && formasi > 0 ? formasi : 0;
    for (let i = 1; i <= maxP; i += 1) {
      p.push(`P-${String(i).padStart(2, '0')}`);
    }
    const s = [];
    const maxS = Number.isFinite(cadangan) && cadangan > 0 ? cadangan : 0;
    for (let i = 1; i <= maxS; i += 1) {
      s.push(`S-${i}`);
    }
    return [...p, ...s];
  }, [formasi, cadangan]);

  const posisiHistoryMap = useMemo(() => {
    const grouped = {};
    (Array.isArray(posisiHistoryRows) ? posisiHistoryRows : []).forEach((row) => {
      const posisi = String(row?.posisi || '').trim();
      if (!posisi) return;
      if (!grouped[posisi]) grouped[posisi] = [];
      grouped[posisi].push(row);
    });
    return grouped;
  }, [posisiHistoryRows]);

  useEffect(() => {
    if (!showPosisiHistoryModal) return;
    const idMt = String(editData?.id_mt || '').trim();
    if (!idMt) {
      setPosisiHistoryRows([]);
      return;
    }
    let ignore = false;
    (async () => {
      setLoadingPosisiHistory(true);
      try {
        const { data } = await api.get(`${backendPort}/api/main/load_ban_history_per_posisi_mt/${idMt}`);
        if (ignore) return;
        const rows = Array.isArray(data) ? data : [];
        setPosisiHistoryRows(rows);
      } catch {
        if (!ignore) setPosisiHistoryRows([]);
      } finally {
        if (!ignore) setLoadingPosisiHistory(false);
      }
    })();
    return () => {
      ignore = true;
    };
  }, [showPosisiHistoryModal, editData?.id_mt, reloadToken]);

  useEffect(() => {
    if (!showPosisiHistoryModal) return;
    const activeHasData = Boolean(posisiHistoryMap?.[selectedHistoryPosisi]?.length);
    if (activeHasData) return;
    const firstWithData = posisiList.find((pos) => Boolean(posisiHistoryMap?.[pos]?.length));
    setSelectedHistoryPosisi(firstWithData || posisiList[0] || '');
  }, [showPosisiHistoryModal, posisiHistoryMap, posisiList, selectedHistoryPosisi]);

  const buildLampiranUrl = (lampiranPath) => {
    if (!lampiranPath) return '#';
    if (String(lampiranPath).startsWith('http')) return lampiranPath;
    return `${backendPort}${lampiranPath}`;
  };

  const close = ()=>{
    setShowDetail(false);
    setShowMaster(true);
  }; 
  const openBanDetailModal = (posisi) => {
    const key = String(posisi || '').trim();
    if (!key) return;
    setSelectedBanPosisi(key);
    setShowBanDetailModal(true);
  };
  const openLampiran = (index) => {
    const files = daftarLampiran
      .filter((item) => Boolean(item?.path))
      .map((item, idx) => ({
        url: String(item.path).startsWith('http') ? item.path : `${backendPort}${item.path}`,
        caption: item?.caption || item?.name || `Lampiran ${idx + 1}`,
        name: item?.name || `Lampiran ${idx + 1}`,
        note: `${editData?.id_mt || ''} - ${item?.caption || item?.name || `Lampiran ${idx + 1}`}`.trim(),
      }));
    if (files.length === 0) return;

    const safeIndex = Number(index);
    const orderedFiles = Number.isFinite(safeIndex) && safeIndex >= 0 && safeIndex < files.length
      ? [files[safeIndex], ...files.filter((_, idx) => idx !== safeIndex)]
      : files;

    setSelectedLampiranFiles(orderedFiles);
    setOpenLampiranModal(true);
  };
  const openPosisiHistoryModal = () => {
    setShowPosisiHistoryModal(true);
    const first = posisiList[0] || '';
    setSelectedHistoryPosisi(first);
  };

  return(
    <div className="col-md-12 page9edit-shell">
      {hoverBanTooltip.visible && hoverBanData && (
        <div
          style={{
            position: 'fixed',
            left: `${Number(hoverBanTooltip.x || 0) + 14}px`,
            top: `${Number(hoverBanTooltip.y || 0) + 14}px`,
            zIndex: 9998,
            pointerEvents: 'none',
            minWidth: '220px',
            maxWidth: '280px',
            padding: '10px 12px',
            borderRadius: '10px',
            border: '1px solid #0f172a',
            background: 'rgba(15, 23, 42, 0.96)',
            color: '#e2e8f0',
            boxShadow: '0 10px 24px rgba(2,6,23,0.35)',
            fontSize: '0.78rem',
            lineHeight: 1.45,
          }}
        >
          <div className="d-flex justify-content-between gap-2">
            <span style={{ color: '#93c5fd' }}>Seri</span>
            <span style={{ fontWeight: 700, textAlign: 'right' }}>{hoverBanData.seri || '-'}</span>
          </div>
          <div className="d-flex justify-content-between gap-2">
            <span style={{ color: '#93c5fd' }}>Status</span>
            <span style={{ fontWeight: 600, textAlign: 'right' }}>{hoverBanData.status || '-'}</span>
          </div>
          <div className="d-flex justify-content-between gap-2">
            <span style={{ color: '#93c5fd' }}>KM Tempuh</span>
            <span style={{ fontWeight: 600, textAlign: 'right' }}>{hoverBanData.km || '-'}</span>
          </div>
          <div className="d-flex justify-content-between gap-2">
            <span style={{ color: '#93c5fd' }}>TD</span>
            <span style={{ fontWeight: 600, textAlign: 'right' }}>{hoverBanData.td || '-'}</span>
          </div>
          <div className="d-flex justify-content-between gap-2">
            <span style={{ color: '#93c5fd' }}>Indikasi</span>
            <span style={{ fontWeight: 600, textAlign: 'right' }}>{hoverIndikasiText}</span>
          </div>
        </div>
      )}
      <ShowPic
        open={openLampiranModal}
        onClose={() => setOpenLampiranModal(false)}
        row={{ catatan: selectedLampiranFiles?.[0]?.caption || "" }}
        backendPort={backendPort}
        token=""
        onUploadSuccess={() => {}}
        readOnly={true}
        customTitle="Lampiran MT"
        customNote={selectedLampiranFiles?.[0]?.caption || ""}
        customFileUrl={selectedLampiranFiles?.[0]?.url || null}
        customFiles={selectedLampiranFiles}
      />
      <div className="card page9edit-card">
        <div className="card-header d-flex justify-content-between align-items-center page9edit-header text-white">
          <span>{`Detail Kendaraan - ${editData?.id_mt || '-'}`}</span>
          <button type="button" className="btn btn-sm btn-outline-light page9show-close-btn" onClick={close}>
            Tutup
          </button>
        </div>
        <div className="card-body page9edit-body">
          <form className="page9edit-form">
            <div className='row g-3'>
              <div className={isBanTerpasangMaximized ? 'd-none' : 'col-md-4'}>
                <div className="card p-3 page9edit-step-card">
                  <div className='row'>
                    <div className="col-md-6 mb-3">
                      <label>Transportir</label>
                      <input className="form-control" value={editData?.transportir || '-'} disabled />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>Cabang</label>
                      <input className="form-control" value={namaCabang} disabled />
                    </div>
                  </div>

                  <div className='row g-2'>
                    <div className="mb-3 col-md-3">
                      <label>No. Polisi</label>
                      <input className="form-control" value={editData?.nopol || '-'} disabled />
                    </div>
                    <div className="mb-3 col-md-3">
                      <label>ODO AWAL</label>
                      <input className="form-control" value={editData?.odo_awal ?? 0} disabled />
                    </div>
                    <div className="mb-3 col-md-3">
                      <label>ODO AKHIR</label>
                      <input className="form-control" value={Number(odoAkhir || 0)} disabled />
                    </div>
                    <div className="mb-3 col-md-3">
                      <label>KM TEMPUH</label>
                      <input className="form-control" value={Number(kmtAkhir || 0)} disabled />
                    </div>
                  </div>

                  <div className='row'>
                    <div className="col-md-6 mb-3">
                      <label>Merk</label>
                      <input className="form-control" value={editData?.merk || '-'} disabled />
                    </div>
                    <div className="mb-3 col-md-6">
                      <label>Tahun Pembuatan</label>
                      <input className="form-control" value={Number(editData?.tahun_pembuatan || 0)} disabled />
                    </div>
                  </div>

                  <div className='row'>
                    <div className="mb-3 col-md-6">
                      <label>Kapasitas</label>
                      <input className="form-control" value={editData?.kapasitas || '-'} disabled />
                    </div>
                    <div className="mb-3 col-md-6">
                      <label>Kategori</label>
                      <input className="form-control" value={editData?.kategori || '-'} disabled />
                    </div>
                  </div>

                  <div className='row'>
                    <div className="mb-3 col-md-6">
                      <label>Formasi Roda</label>
                      <input className="form-control" value={Number(editData?.roda || 0)} disabled />
                    </div>
                    <div className="mb-3 col-md-6">
                      <label>Ban Cadangan</label>
                      <input className="form-control" value={editData?.cadangan ?? 0} disabled />
                    </div>
                  </div>

                  <div className='row'>
                    <div className="mb-3 col-md-6">
                      <label>Status OTF</label>
                      <input className="form-control" value={editData?.status || '-'} disabled />
                    </div>
                    <div className="mb-3 col-md-6">
                      <label>Tanggal KIR</label>
                      <input className="form-control" value={formatTglUntukUI(editData?.kir)} disabled />
                    </div>
                  </div>

                  <div className='row'>
                    <div className="col-md-6 mb-3">
                      <label>Tanggal Input</label>
                      <input className="form-control" value={formatTglUntukUI(editData?.tanggal)} disabled />
                    </div>
                    <div className="mb-3 col-md-6">
                      <label>User Input</label>
                      <input className="form-control" value={editData?.user || '-'} disabled />
                    </div>
                  </div>
                </div>
              </div>

              <div className={isBanTerpasangMaximized ? 'col-md-8' : 'col-md-4'}>
                <div className={`card p-3 page9edit-step-card page9show-ban-card${isBanTerpasangMaximized ? ' is-maximized' : ''}`}>
                  <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
                    <h5 className="page9edit-step-title mb-0">Ban Terpasang</h5>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary page9show-maximize-btn"
                      onClick={() => {
                        hideBanTooltip();
                        setIsBanTerpasangMaximized((prev) => !prev);
                      }}
                    >
                      {isBanTerpasangMaximized ? 'Default' : 'Maximize'}
                    </button>
                  </div>
                  {isBanTerpasangMaximized ? (
                    <Page9ShowFormasiBanMaximized
                      formasi={formasi}
                      cadangan={cadangan}
                      onClick={openBanDetailModal}
                      daftarKodeBan={daftarBanMap}
                      unevenWearPosisi={unevenWearPosisi}
                      buildBanTooltipData={buildBanTooltipData}
                      buildBanIndikasiText={buildBanIndikasiText}
                    />
                  ) : (
                    <FormasiBan
                      formasi={formasi}
                      cadangan={cadangan}
                      onClick={openBanDetailModal}
                      daftarKodeBan={daftarBanMap}
                      warningPosisi={tdWarningPosisi}
                      unevenWearPosisi={unevenWearPosisi}
                      onBanHover={showBanTooltip}
                      onBanLeave={hideBanTooltip}
                    />
                  )}
                </div>
              </div>

              <div className='col-md-4'>
                <div className="page9show-stack">
                  <div className="card p-3 page9edit-step-card">
                    <h5 className="page9edit-step-title mb-2">Historical MT</h5>
                    <div className="page9show-list" style={{ maxHeight: 320, overflowY: 'auto', paddingRight: 4 }}>
                      {loadingHistoryMt && (
                        <StatRow
                          label="Memuat histori MT..."
                          value="-"
                          variant="neutral"
                          onClick={null}
                        />
                      )}
                      {!loadingHistoryMt && historyRows.length === 0 && (
                        <StatRow
                          label="Belum ada histori MT"
                          value="-"
                          variant="neutral"
                          onClick={null}
                        />
                      )}
                      {historyRows.map((row, idx) => (
                        <div key={`history-${idx}`} className="page9show-row" style={{ gridTemplateColumns: '1fr', gap: 6 }}>
                          <div className="d-flex justify-content-between align-items-center gap-2">
                            <span className="page9show-row-label fw-semibold">{row.label}</span>
                            <span className={`page9show-chip is-${row.variant}`}>{row.value}</span>
                          </div>
                          <div className="small text-muted">{`ODO: ${Number(row.odo || 0).toLocaleString('id-ID')} | KM Tempuh: ${Number(row.kmtotal || 0).toLocaleString('id-ID')}`}</div>
                          <div className="small">{row.info || '-'}</div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="card p-3 page9edit-step-card">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <h5 className="page9edit-step-title mb-0">Historical Ban Per Posisi</h5>
                      <button type="button" className="btn btn-sm btn-outline-primary" onClick={openPosisiHistoryModal}>
                        LIHAT
                      </button>
                    </div>
                  </div>

                  <div className="card p-3 page9edit-step-card">
                    <h5 className="page9edit-step-title mb-2">Lampiran</h5>
                    <div className="page9show-list">
                      {daftarLampiran.length === 0 && (
                        <StatRow
                          label="Belum ada lampiran"
                          value="-"
                          variant="neutral"
                          onClick={null}
                        />
                      )}
                      {daftarLampiran.map((item, idx) => {
                        const caption = item?.caption?.trim() || '-';
                        const fileName = item?.name || `Lampiran ${idx + 1}`;
                        const fileUrl = buildLampiranUrl(item?.path);
                        const mimeType = String(item?.type || '').toLowerCase();
                        const extSource = `${item?.name || ''} ${item?.path || ''}`;
                        const isImage = mimeType.startsWith('image/')
                          || /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(extSource);
                        return (
                          <StatRow
                            key={`${fileName}-${idx}`}
                            label={caption}
                            secondaryLabel={fileName}
                            rightContent={<LampiranTypeBadge isImage={isImage} />}
                            variant={fileUrl !== '#' ? 'link' : 'neutral'}
                            onClick={() => {
                              if (fileUrl !== '#') openLampiran(idx);
                            }}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      {showBanDetailModal && (
        <ModalBanShow
          open={showBanDetailModal}
          onClose={() => setShowBanDetailModal(false)}
          globalOpsi={globalOpsi}
          selectedPosisi={selectedBanPosisi}
          idBan={Number(daftarBanMap?.[selectedBanPosisi] || 0)}
          reloadToken={reloadToken}
        />
      )}
      {showPosisiHistoryModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.35)' }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div>
                  <h5 className="modal-title mb-0">Historical Ban Per Posisi</h5>
                  <small className="text-muted">{`${editData?.id_mt || '-'} | No Pol. ${editData?.nopol || '-'}`}</small>
                </div>
                <button type="button" className="btn-close" onClick={() => setShowPosisiHistoryModal(false)} />
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-5">
                    <h6 className="mb-2">Pilih Posisi</h6>
                    <FormasiBan
                      formasi={formasi}
                      cadangan={cadangan}
                      onClick={(pos) => setSelectedHistoryPosisi(String(pos || '').trim())}
                      daftarKodeBan={{}}
                      highlightedPosisi={selectedHistoryPosisi}
                    />
                  </div>
                  <div className="col-md-7">
                    <h6 className="mb-2">
                      {selectedHistoryPosisi ? `Historical Posisi ${selectedHistoryPosisi}` : 'Historical Posisi'}
                    </h6>
                    <div style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: 4 }}>
                      {loadingPosisiHistory && <div className="text-muted">Memuat historical ban per posisi...</div>}
                      {!loadingPosisiHistory && !(posisiHistoryMap?.[selectedHistoryPosisi]?.length) && (
                        <div className="text-muted">Belum ada historical ban pada posisi ini.</div>
                      )}
                      {!loadingPosisiHistory && (posisiHistoryMap?.[selectedHistoryPosisi] || []).map((row, idx) => (
                        <div key={`${row?.id_ban || 'ban'}-${row?.tanggal || '-'}-${idx}`} className="card mb-2">
                          <div className="card-body py-2">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                              <span className={`page9show-chip is-${getEventVariant(row?.event)}`}>
                                {String(row?.event || '-').toUpperCase()}
                              </span>
                              <small className="text-muted">{`(${formatTglUntukUI(row?.tanggal)})`}</small>
                            </div>
                            <div className="row g-1 small">
                              <div className="col-6"><strong>Status:</strong> {row?.status || '-'}</div>
                              <div className="col-6"><strong>Seri Ban:</strong> {row?.seri_ban || '-'}</div>
                              <div className="col-6"><strong>Merk:</strong> {row?.merk || '-'}</div>
                              <div className="col-6"><strong>Ukuran:</strong> {row?.ukuran || '-'}</div>
                              <div className="col-12">
                                {normalizePlaceInText(row?.info)}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowPosisiHistoryModal(false)}>
                  Tutup
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
)}

function StatRow ({ label, secondaryLabel = '', value, onClick, variant = 'neutral', rightContent = null }) {
  const clickable = typeof onClick === 'function';
  const rowClickable = clickable && Boolean(rightContent);
  return (
    <div
      className="page9show-row"
      onClick={rowClickable ? onClick : undefined}
      role={rowClickable ? 'button' : undefined}
      tabIndex={rowClickable ? 0 : undefined}
      onKeyDown={rowClickable ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') onClick();
      } : undefined}
      style={rowClickable ? { cursor: 'pointer' } : undefined}
    >
      <div className="page9show-row-text">
        <span className="page9show-row-label">{label}</span>
        {secondaryLabel ? <small className="page9show-row-secondary">{secondaryLabel}</small> : null}
      </div>
      {rightContent ? (
        <div className="page9show-icon-wrap">{rightContent}</div>
      ) : (
        <button
          type="button"
          className={`page9show-chip is-${variant}`}
          onClick={clickable ? onClick : undefined}
          disabled={!clickable}
        >
          {value}
        </button>
      )}
    </div>
  );
}

function LampiranTypeBadge({ isImage }) {
  return (
    <span className={`page9show-icon-badge ${isImage ? 'is-image' : 'is-doc'}`} title={isImage ? 'Gambar' : 'Dokumen'}>
      {isImage ? (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="currentColor" d="M4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5Zm2 0v10.2l3.1-3.1a1 1 0 0 1 1.4 0l2.4 2.4l2.6-2.6a1 1 0 0 1 1.4 0L18 13.1V5H6Zm2.8 4.5a1.7 1.7 0 1 0 0-3.4a1.7 1.7 0 0 0 0 3.4Z"/>
        </svg>
      ) : (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="currentColor" d="M7 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8.5L14.5 2H7Zm7 1.5L18.5 8H14V3.5ZM8 12a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2H8Zm0 4a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2H8Z"/>
        </svg>
      )}
    </span>
  );
}
